import surfImg from "./home-bg-surf.jpg";
import skateImg from "./home-bg-skate.jpg";
import snowImg from "./home-bg-snow.jpg";
import { useState, useEffect } from "react";
import { useMostRecentOrganisation } from "./useRecentOrganisations";

const waterSports = [
    "surf",
    "wake",
    "skim",
    "bodyboard",
    "paddle",
    "windsurf",
    "sls",
];
const skateSports = ["skate", "bmx", "scooter", "fmb"];
const snowSports = ["snow", "freeride"];

const defaultColor = "#333333";

interface Background {
    img: string;
    color: string;
}

const surfBackground = { img: surfImg, color: "#2d5c76" };
const skateBackground = { img: skateImg, color: "#5c482f" };
const snowBackground = { img: snowImg, color: "#aaccf2" };

const sportTypeBackgrounds: Record<string, Background> = {
    ...Object.fromEntries(waterSports.map((sport) => [sport, surfBackground])),
    ...Object.fromEntries(skateSports.map((sport) => [sport, skateBackground])),
    ...Object.fromEntries(snowSports.map((sport) => [sport, snowBackground])),
};

const allBackgrounds = [surfBackground, skateBackground, snowBackground];

export const useHeaderBackground = () => {
    const mostRecentOrg = useMostRecentOrganisation();
    const [background, setBackground] = useState("");
    const [backgroundColor, setBackgroundColor] = useState(defaultColor);
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        const sportType = mostRecentOrg?.sportType?.toLowerCase();
        let bg = { img: "", color: "" };

        if (
            !sportType ||
            sportType === "other" ||
            !sportTypeBackgrounds[sportType]
        ) {
            const randomIndex = Math.floor(
                Math.random() * allBackgrounds.length,
            );
            bg = allBackgrounds[randomIndex];
        } else {
            bg = sportTypeBackgrounds[sportType];
        }

        setBackground(bg.img);
        setBackgroundColor(bg.color);
        setImageLoaded(false);

        const img = new Image();
        img.src = bg.img;
        img.onload = () => {
            setImageLoaded(true);
        };

        return () => {
            img.onload = null;
        };
    }, [mostRecentOrg]);

    return { background, backgroundColor, imageLoaded };
};
